// Misc
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import isNil from 'lodash/isNil'

// Constants
import { WEEKDAYS, WEEKEND, DAYS_LIST } from 'constants/availabilityWeekPatterns'

// Atoms
import DialogContent from '@material-ui/core/DialogContent'
import Button from '@material-ui/core/Button'
import FormDialog from 'atoms/FormDialog'
import TimePicker from 'atoms/TimePicker'
import Spacer from 'atoms/Spacer'
import Select from 'atoms/Select'

const minuteToDate = (minute) => {
  return isNil(minute) ? null : moment().startOf('day').add(minute, 'minutes').toDate()
}

const dateToMinute = (date) => {
  return moment(date).diff(moment().startOf('day'), 'minutes')
}

export default class ScheduleItemEditDialog extends Component {
  static propTypes = {
    item: PropTypes.shape({
      startTimeMinute: PropTypes.number.isRequired,
      endTimeMinute: PropTypes.number,
      weekDay: PropTypes.number.isRequired,
    }),
    open: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    defaultWeekDay: PropTypes.any,
    addFormTitle: PropTypes.string.isRequired,
    editFormTitle: PropTypes.string.isRequired,
  }

  static defaultProps = {
    defaultWeekDay: WEEKDAYS
  }

  state = {}

  static getDerivedStateFromProps = (nextProps, prevState) => {
    const { item, open, defaultWeekDay } = nextProps
    if (open && open !== prevState.open) {
      const { weekDay = defaultWeekDay, startTimeMinute, endTimeMinute } = item || {}
      return {
        open,
        weekDay,
        startTimeDate: minuteToDate(startTimeMinute),
        endTimeDate: minuteToDate(endTimeMinute),
      }
    }
    return { open }
  }

  isEditing = () => {
    const { item } = this.props
    return !!item
  }

  handleSubmit = () => {
    const { onSubmit } = this.props
    const { startTimeDate, endTimeDate, weekDay } = this.state

    const itemData = {
      startTimeMinute: dateToMinute(startTimeDate),
      endTimeMinute: endTimeDate && dateToMinute(endTimeDate),
      weekDay
    }

    if (weekDay === WEEKDAYS || weekDay === WEEKEND) {
      const multipleItems = DAYS_LIST[weekDay].map(day => ({
        ...itemData,
        weekDay: day,
      }))
      onSubmit(multipleItems)
    } else {
      onSubmit(itemData)
    }
  }

  handleDateTimeChange = fieldName => (date) => {
    this.setState({ [fieldName]: date })
  }

  handleWeekDayChange = (ev, weekDay) => {
    this.setState({ weekDay })
  }

  renderTimePicker(fieldName, props) {
    const { [fieldName]: date } = this.state
    return (
      <TimePicker
        {...props}
        required
        withBorder
        defaultDate={date}
        onChange={this.handleDateTimeChange(fieldName)}
      />
    )
  }

  renderWeekDaySelect() {
    const { weekDay } = this.state

    const weekDays = [
      ...(!this.isEditing() ? [
        { value: WEEKDAYS, label: 'Weekdays (Monday - Friday)' },
        { value: WEEKEND, label: 'Weekend (Saturday, Sunday)' },
      ] : []),
      // ISO week day indices
      { value: 1, label: 'Monday' },
      { value: 2, label: 'Tuesday' },
      { value: 3, label: 'Wednesday' },
      { value: 4, label: 'Thursday' },
      { value: 5, label: 'Friday' },
      { value: 6, label: 'Saturday' },
      { value: 7, label: 'Sunday' },
    ]

    return (
      <Select
        label="Day of week"
        withBorder
        value={weekDay}
        items={weekDays}
        renderItem={({ label }) => label}
        getItemValue={({ value }) => value}
        onChange={this.handleWeekDayChange}
      />
    )
  }

  render() {
    const { addFormTitle, editFormTitle } = this.props
    const { startTimeDate } = this.state
    return (
      <FormDialog
        {...this.props}
        title={this.isEditing() ? editFormTitle : addFormTitle}
        onSubmit={this.handleSubmit}
        applyButton={<Button>Confirm</Button>}
        cancelButton={<Button>Cancel</Button>}
      >
        <DialogContent>
          { this.renderWeekDaySelect() }
          <Spacer />
          { this.renderTimePicker('startTimeDate', {
            label: 'Start time',
            placeholder: 'Enter start time here',
          }) }
          <Spacer />
          { this.renderTimePicker('endTimeDate', {
            label: 'End time',
            placeholder: 'Enter end time here',
            minDate: startTimeDate,
            minDateErrorMessage: 'End date can\'t be before start date',
          }) }
        </DialogContent>
      </FormDialog>
    )
  }
}
